(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bm-ads-events"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.biomeDiagnosticsReady) return;
  window.biomeDiagnosticsReady = true;
  const ready = () => {
    const node = document.getElementById('bm-ads-config');
    if (!node) return;
    let config;
    try { config = JSON.parse(node.textContent); } catch (error) { return; }
    if (!config.published || window.Shopify?.designMode) return;
    const allowed = () => {
      const privacy = window.Shopify?.customerPrivacy;
      try { return privacy?.analyticsProcessingAllowed?.() === true && privacy?.marketingAllowed?.() === true; }
      catch (error) { return false; }
    };
    if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], () => {});
    }
    const actions = new Set(['add','quantity','remove','discount','checkout']);
    const states = new Set(['confirmed','rejected','uncertain','intent']);
    const locations = new Set(['product','sticky','quick_add','cart','protocol']);
    document.addEventListener('bm:diagnostic', event => {
      if (!allowed() || typeof window.Shopify?.analytics?.publish !== 'function') return;
      const data = event.detail || {};
      if (!actions.has(data.action) || !states.has(data.state) || !locations.has(data.placement)) return;
      const payload = {version:1,action:data.action,state:data.state,placement:data.placement};
      try {
        const result = window.Shopify.analytics.publish('biome:storefront_action',payload);
        if (result && typeof result.catch === 'function') result.catch(() => {});
      } catch (error) {}
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',ready,{once:true});
  else ready();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bm-cart-advantages-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
 const start=()=>{
  const node=document.getElementById('bm-advantages-config');if(!node)return;
  const config=JSON.parse(node.textContent);
  const notice=document.querySelector('[data-bm-cart-notice]');
  const upsell=notice?.querySelector('[data-bm-upsell]');
  const cards=notice?.querySelector('[data-bm-upsell-products]');
  const template=document.getElementById('bm-upsell-card-template');
  const catalogueNode=document.getElementById('bm-upsell-catalog');
  let catalogue={products:[],cartTokens:{}};
  try{if(catalogueNode)catalogue=JSON.parse(catalogueNode.textContent);}catch(error){}
  let products=new Map((catalogue.products||[]).map(p=>[Number(p.id),p]));
  let sourceId=null;let returnFocus=null;let refreshPromise=null;let refreshAttempted=false;
  const money=n=>new Intl.NumberFormat('ro-RO',{style:'currency',currency:config.currency}).format(n/100).replace(/\s*RON$/,' lei');
  const tokensFor=id=>products.get(Number(id))?.tokens||catalogue.cartTokens?.[String(id)];
  const suggestions=cart=>{
   const source=products.get(Number(sourceId));
   if(!source||!Array.isArray(source.recommendations)||!Array.isArray(source.tokens)||!source.tokens.length)return [];
   if(!cart.items.length||cart.items.some(item=>item.selling_plan_allocation||!Array.isArray(tokensFor(item.product_id))||!tokensFor(item.product_id).length))return [];
   const ids=new Set(cart.items.map(item=>Number(item.product_id)));
   const ingredients=new Set(cart.items.flatMap(item=>tokensFor(item.product_id)).concat(source.tokens));
   const eligible=source.recommendations.map(id=>products.get(Number(id))).filter(p=>p&&p.allowed&&p.available&&Number(p.price)>0&&p.image&&Number(p.id)!==Number(sourceId)&&!ids.has(Number(p.id))&&Array.isArray(p.tokens)&&p.tokens.length&&!p.tokens.some(token=>ingredients.has(token)));
   return Array.from(new Map(eligible.map(p=>[Number(p.id),p])).values()).slice(0,2);
  };
  const renderSuggestions=cart=>{
   if(!upsell||!cards||!template)return;
   const recommendations=suggestions(cart);
   upsell.hidden=recommendations.length===0;
   const source=products.get(Number(sourceId));
   if(source)notice.querySelector('[data-bm-upsell-context]').textContent=config.messages.context.replace('[product]',source.title);
   const hadFocus=cards.contains(document.activeElement);
   const fragment=document.createDocumentFragment();
   for(const product of recommendations){
    const card=template.content.firstElementChild.cloneNode(true);
    card.elements.id.value=product.variant;
    card.querySelectorAll('[data-bm-upsell-link]').forEach(link=>{link.href=product.url;});
    card.querySelector('[data-bm-upsell-title]').textContent=product.title;
    card.querySelector('[data-bm-upsell-detail]').textContent=product.detail;
    card.querySelector('[data-bm-upsell-price]').textContent=money(product.price);
    card.querySelector('[data-bm-upsell-image]').src=product.image;
    card.querySelector('[data-bm-upsell-add]').setAttribute('aria-label',config.messages.label.replace('[product]',product.title));
    fragment.append(card);
   }
   cards.replaceChildren(fragment);
   if(hadFocus&&!notice.hidden)notice.querySelector('h2')?.focus({preventScroll:true});
  };
  const render=cart=>{
   if(!cart||!Array.isArray(cart.items))return;
   config.cart=cart;
   document.querySelectorAll('[data-bm-advantages-body]').forEach(body=>{
    const shipping=body.querySelector('[data-bm-advantage-shipping]');const progress=body.querySelector('[data-bm-advantage-progress]');
    const domestic=config.country==='RO'&&(cart.currency||config.currency)==='RON'&&cart.requires_shipping!==false&&cart.item_count>0;
    shipping.hidden=!domestic;progress.hidden=!domestic;progress.max=config.threshold;progress.value=Math.min(cart.total_price,config.threshold);
    const left=Math.max(0,config.threshold-cart.total_price);shipping.textContent=left?config.messages.shipping.replace('[amount]',money(left)):config.messages.free;
   });
   renderSuggestions(cart);
  };
  const refreshCatalogue=()=>{
   if(refreshPromise)return refreshPromise;
   if(refreshAttempted)return Promise.resolve();
   refreshAttempted=true;
   const url=new URL(config.root||'/',window.location.origin);url.searchParams.set('section_id','bm-upsell-catalog');
   const controller=new AbortController();const timeout=setTimeout(()=>controller.abort(),10000);
   refreshPromise=fetch(url,{credentials:'same-origin',signal:controller.signal}).then(response=>{if(!response.ok)throw new Error();return response.text();}).then(html=>{
    const dataNode=new DOMParser().parseFromString(html,'text/html').getElementById('bm-upsell-catalog');if(!dataNode)return;
    const next=JSON.parse(dataNode.textContent);if(!Array.isArray(next.products))return;
    catalogue=next;products=new Map(next.products.map(p=>[Number(p.id),p]));renderSuggestions(config.cart);
   }).catch(()=>{}).finally(()=>{clearTimeout(timeout);refreshPromise=null;});
   return refreshPromise;
  };
  const close=()=>{if(notice){const restore=notice.contains(document.activeElement);notice.hidden=true;if(restore&&returnFocus?.isConnected)returnFocus.focus({preventScroll:true});}};
  document.addEventListener('bm:cart-updated',e=>render(e.detail));
  document.addEventListener('bm:cart-added',e=>{
   const cart=e.detail;if(!cart||!Array.isArray(cart.items))return;
   if(cart.bmPlacement!=='cross_sell'||sourceId===null){const addedIds=cart.bmAddedVariantIds||[];const line=cart.items.find(item=>addedIds.includes(Number(item.variant_id)));sourceId=line?.product_id||null;}
   render(cart);
   if(!products.has(Number(sourceId))||cart.items.some(item=>!Array.isArray(tokensFor(item.product_id))))refreshCatalogue();
   if(!notice||document.querySelector('dialog[open]'))return;
   const toast=document.getElementById('bm-toast');if(toast)toast.hidden=true;
   if(notice.hidden)returnFocus=document.activeElement;
   notice.hidden=false;
  });
  document.addEventListener('click',e=>{if(e.target.closest('[data-bm-notice-close]'))close();});
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&notice&&!notice.hidden)close();});
  render(config.cart);
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bm-data-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
  function selectSheet(tab, focus) {
    const gallery = tab.closest('[data-bm-sheets]');
    if (!gallery) return;
    gallery.querySelectorAll('[role="tab"]').forEach(item => {
      const selected = item === tab;
      item.setAttribute('aria-selected', String(selected));
      item.tabIndex = selected ? 0 : -1;
      const panel = document.getElementById(item.getAttribute('aria-controls'));
      if (panel) panel.hidden = !selected;
    });
    const counter = gallery.querySelector('[data-bm-sheet-count]');
    if (counter) counter.textContent = `0${tab.dataset.bmSheetPosition} / 04`;
    if (focus) tab.focus();
  }
  document.addEventListener('click', event => {
    const tab = event.target.closest('[data-bm-sheet-tab]');
    if (tab) selectSheet(tab, false);
  });
  document.addEventListener('keydown', event => {
    const tab = event.target.closest('[data-bm-sheet-tab]');
    if (!tab || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
    event.preventDefault();
    const tabs = [...tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]')];
    let index = tabs.indexOf(tab);
    index = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    selectSheet(tabs[index], true);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bm-ingredient-wall"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = () => {
    document.querySelectorAll('[data-bm-ingredient-wall]').forEach(wall => {
      if (wall.dataset.initialized) return;
      wall.dataset.initialized = 'true';
      const entries = [...wall.querySelectorAll('[data-bm-ingredient-entry]')];
      const controls = wall.querySelector('[data-bm-ingredient-controls]');
      const search = wall.querySelector('[data-bm-ingredient-search]');
      const buttons = [...wall.querySelectorAll('[data-bm-ingredient-letter]')];
      const expand = wall.querySelector('[data-bm-ingredient-expand]');
      const status = wall.querySelector('[data-bm-ingredient-status]');
      const empty = wall.querySelector('[data-bm-ingredient-empty]');
      let letter = 'all';
      let expanded = false;
      const normalize = value => value.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLocaleLowerCase('ro').trim();
      const render = announce => {
        const term = normalize(search.value);
        const matches = entries.filter(entry => (letter === 'all' || entry.dataset.letter === letter) && normalize(entry.dataset.label).includes(term));
        const compact = letter === 'all' && !term && !expanded;
        const visible = compact ? matches.slice(0, 12) : matches;
        entries.forEach(entry => { entry.hidden = !visible.includes(entry); });
        expand.hidden = !compact || matches.length <= 12;
        empty.hidden = matches.length > 0;
        buttons.forEach(button => { button.setAttribute('aria-pressed', String(button.dataset.bmIngredientLetter === letter)); });
        if (announce) status.textContent = matches.length + (matches.length === 1 ? ' ingredient găsit.' : ' ingrediente găsite.');
      };
      buttons.forEach(button => button.addEventListener('click', () => {
        letter = button.dataset.bmIngredientLetter;
        search.value = '';
        render(true);
      }));
      search.addEventListener('input', () => { letter = 'all'; render(true); });
      expand.addEventListener('click', () => { expanded = true; render(true); entries[12]?.focus({ preventScroll: true }); });
      controls.hidden = false;
      render(false);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bm-pdp-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bm-delivery-estimate')) {
  class BmDeliveryEstimate extends HTMLElement {
    static easter(year) {
      const a = year % 4;
      const b = year % 7;
      const c = year % 19;
      const d = (19 * c + 15) % 30;
      const e = (2 * a + 4 * b - d + 34) % 7;
      const month = Math.floor((d + e + 114) / 31);
      const day = (d + e + 114) % 31 + 1;
      const correction = Math.floor(year / 100) - Math.floor(year / 400) - 2;
      return new Date(Date.UTC(year,month - 1,day + correction,12));
    }
    static dateKey(date) { return date.toISOString().slice(0,10); }
    static holidays(year) {
      const dates = ['01-01','01-02','01-06','01-07','01-24','05-01','06-01','08-15','11-30','12-01','12-25','12-26'].map(day => `${year}-${day}`);
      const easter = this.easter(year);
      for (const offset of [-2,0,1,49,50]) {
        const day = new Date(easter);
        day.setUTCDate(day.getUTCDate() + offset);
        dates.push(this.dateKey(day));
      }
      return new Set(dates);
    }
    static businessDate(start,days) {
      const date = new Date(start);
      let remaining = days;
      while (remaining > 0) {
        date.setUTCDate(date.getUTCDate() + 1);
        const weekday = date.getUTCDay();
        if (weekday !== 0 && weekday !== 6 && !this.holidays(date.getUTCFullYear()).has(this.dateKey(date))) remaining--;
      }
      return date;
    }
    connectedCallback() {
      const parts = new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Bucharest',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
      const value = type => Number(parts.find(part => part.type === type)?.value);
      const start = new Date(Date.UTC(value('year'),value('month') - 1,value('day'),12));
      const minimum = Math.max(1,Math.min(14,Number(this.dataset.minDays) || 1));
      const maximum = Math.max(minimum,Math.min(14,Number(this.dataset.maxDays) || 3));
      const formatter = new Intl.DateTimeFormat('ro-RO',{timeZone:'UTC',day:'numeric',month:'long'});
      const first = formatter.format(BmDeliveryEstimate.businessDate(start,minimum));
      const last = formatter.format(BmDeliveryEstimate.businessDate(start,maximum));
      this.textContent = `Livrare estimată: ${first}${first === last ? '' : ` – ${last}`}`;
    }
  }
  customElements.define('bm-delivery-estimate',BmDeliveryEstimate);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bm-pdp-purchase-strip"] && !Shopify.designMode) return;
  try {
    (() => {
  const setup = () => {
    document.querySelectorAll('[data-bm-pdp]').forEach(pdp => {
      if (pdp.classList.contains('bm-shortcuts-ready')) return;
      const strip = pdp.querySelector('[data-bm-purchase-strip]');
      const form = pdp.querySelector('.bm-product-form');
      const primary = form?.querySelector('[data-bm-atc]');
      if (!strip || !primary || !window.IntersectionObserver) return;
      pdp.classList.add('bm-shortcuts-ready');
      let primaryVisible = true;
      let stripVisible = false;
      const observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (entry.target === primary) primaryVisible = entry.isIntersecting;
          if (entry.target === strip) stripVisible = entry.isIntersecting;
        }
        const passedPrimary = primary.getBoundingClientRect().bottom < 0;
        pdp.classList.toggle('bm-show-purchase-shortcut',passedPrimary && !primaryVisible && !stripVisible);
      },{threshold:0});
      observer.observe(primary);
      observer.observe(strip);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',setup,{once:true}); else setup();
  document.addEventListener('shopify:section:load',setup);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bm-quantity-offers"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('bm-quantity-offers')) return;
  class BmQuantityOffers extends HTMLElement {
    static discountRate(quantity, eligible) {
      return eligible ? quantity >= 6 ? 10 : quantity >= 3 ? 5 : 0 : 0;
    }
    static offerTotal(price, quantity, eligible) {
      return Math.round(price * (100 - this.discountRate(quantity,eligible)) / 100) * quantity;
    }
    static quantityChoices({price=0,threshold=15000,shippingEligible=false,discountEligible=false,minimum=1,increment=1}) {
      const first = Math.max(1,Number(minimum) || 1);
      const step = Math.max(1,Number(increment) || 1);
      const align = target => first + Math.max(0,Math.ceil((target - first) / step)) * step;
      let targets = [first,3,6];
      if (shippingEligible && price < threshold) {
        if (price * 2 >= threshold) targets = [first,2,3];
        else if (this.offerTotal(price,3,discountEligible) < threshold && this.offerTotal(price,4,discountEligible) >= threshold) targets = [first,4,6];
      }
      const quantities = targets.map(align);
      return quantities.map((quantity,index) => quantity <= 6 && quantities.indexOf(quantity) === index ? quantity : null);
    }
    static validQuantity(quantity, {minimum,increment,maximum,available}) {
      return available && Number.isSafeInteger(quantity) && quantity >= minimum && quantity <= maximum && (quantity - minimum) % increment === 0;
    }
    connectedCallback() {
      queueMicrotask(() => this.initialize());
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
    }
    initialize() {
      if (!this.isConnected || this.abort && !this.abort.signal.aborted) return;
      this.form = this.closest('form');
      this.pdp = this.closest('[data-bm-pdp]');
      this.quantity = this.form?.querySelector('[name="quantity"]');
      const variantNode = this.pdp?.querySelector('[data-bm-variants]');
      if (!this.quantity || !variantNode) return;
      this.config = JSON.parse(this.querySelector('[data-bm-offers-config]').textContent);
      this.variants = JSON.parse(variantNode.textContent);
      this.cartItems = this.config.cart_items;
      this.packTemplate = this.querySelector('.bm-offer-pack')?.cloneNode(true);
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-bm-offer-quantity]');
        if (!button || button.disabled || this.form.getAttribute('aria-busy') === 'true') return;
        this.quantity.value = button.dataset.bmOfferQuantity;
        this.quantity.dispatchEvent(new Event('change',{bubbles:true}));
      }, options);
      this.form.addEventListener('change', event => {
        if (!event.target.matches('[name="quantity"],[data-bm-variant],[name="selling_plan"]')) return;
        const changedVariant = event.target.matches('[data-bm-variant]');
        queueMicrotask(() => this.update(changedVariant));
      }, options);
      this.quantity.addEventListener('input', () => this.update(false), options);
      document.addEventListener('bm:cart-updated', event => {
        const cart = event.detail?.cart || event.detail;
        if (!Array.isArray(cart?.items)) return;
        this.cartItems = cart.items;
        this.update(true);
      }, options);
      this.observer = new MutationObserver(() => this.update(false));
      this.observer.observe(this.form,{attributes:true,attributeFilter:['aria-busy']});
      this.update(true);
    }
    money(value) {
      return new Intl.NumberFormat(this.dataset.locale || 'ro-RO',{style:'currency',currency:this.dataset.currency || 'RON'}).format(value / 100).replace(/\s*RON$/,' lei');
    }
    message(key, value) {
      return this.config.messages[key].replace('__value__', value);
    }
    rate(quantity, subscription) {
      return BmQuantityOffers.discountRate(quantity,this.dataset.discountEligible === 'true' && !subscription);
    }
    update(clamp) {
      if (!this.isConnected) return;
      const variantId = this.form.querySelector('[name="id"]')?.value;
      const variant = this.variants.find(item => String(item.id) === variantId);
      if (!variant) return;
      const plan = this.form.querySelector('[name="selling_plan"]')?.value;
      const allocation = variant.selling_plan_allocations?.find(item => String(item.selling_plan_id || item.selling_plan?.id) === plan);
      const price = allocation?.price ?? variant.price;
      const minimum = Number(variant.quantity_rule?.min) || 1;
      const increment = Number(variant.quantity_rule?.increment) || 1;
      let maximum = variant.quantity_rule?.max == null ? Infinity : Number(variant.quantity_rule.max);
      if (variant.inventory_management && variant.inventory_policy === 'deny') {
        const inCart = this.cartItems.filter(item => String(item.variant_id || item.id) === variantId).reduce((total,item) => total + Number(item.quantity || 0),0);
        maximum = Math.min(maximum,Math.max(0,Number(variant.inventory_quantity || 0) - inCart));
      }
      this.quantity.min = String(minimum);
      this.quantity.step = String(increment);
      if (Number.isFinite(maximum)) this.quantity.max = String(maximum);
      else this.quantity.removeAttribute('max');
      if (clamp && maximum >= minimum) {
        let next = Math.max(minimum,Math.min(Number(this.quantity.value) || minimum,maximum));
        next = minimum + Math.floor((next - minimum) / increment) * increment;
        this.quantity.value = String(next);
      }
      const selected = Number(this.quantity.value);
      const busy = this.form.getAttribute('aria-busy') === 'true';
      const valid = quantity => BmQuantityOffers.validQuantity(quantity,{minimum,increment,maximum,available:variant.available});
      const discountEligible = this.dataset.discountEligible === 'true' && !plan;
      const shippingEligible = this.dataset.roShipping === 'true';
      const threshold = Number(this.dataset.shippingThreshold);
      const shippingCost = Number(this.dataset.shippingCost) || 0;
      const choices = BmQuantityOffers.quantityChoices({price,threshold,shippingEligible,discountEligible,minimum,increment});
      const visibleChoices = choices.filter(quantity => quantity !== null);
      this.querySelector('.bm-offers-fieldset').hidden = visibleChoices.length === 0;
      this.querySelector('.bm-offers-grid').style.setProperty('--offer-columns',String(Math.max(1,visibleChoices.length)));
      const largestChoice = visibleChoices.filter(valid).at(-1);
      const largestGap = largestChoice == null ? 0 : Math.max(0,threshold - BmQuantityOffers.offerTotal(price,largestChoice,discountEligible));
      const completeCart = this.querySelector('[data-bm-offers-complete-cart]');
      completeCart.hidden = !shippingEligible || largestChoice == null || largestGap === 0;
      if (!completeCart.hidden) {
        const quantityLabel = largestChoice === 1 ? this.config.messages.oneItem : this.message('items',String(largestChoice));
        completeCart.textContent = this.message('completeCart',this.money(largestGap)).replace('__quantity__',quantityLabel.toLocaleLowerCase(this.dataset.locale || 'ro-RO'));
      }
      for (const button of this.querySelectorAll('[data-bm-offer-quantity]')) {
        const position = Number(button.dataset.bmOfferPosition);
        const quantity = choices[position];
        button.hidden = quantity == null;
        if (quantity == null) {
          button.disabled = true;
          button.setAttribute('aria-pressed','false');
          continue;
        }
        button.dataset.bmOfferQuantity = String(quantity);
        button.querySelector('[data-bm-offer-title]').textContent = quantity === 1 ? this.config.messages.oneItem : this.message('items',String(quantity));
        const rate = this.rate(quantity,Boolean(plan));
        const total = BmQuantityOffers.offerTotal(price,quantity,discountEligible);
        const shippingIncluded = shippingEligible && total >= threshold && valid(quantity);
        const referenceQuantity = position === 2 ? choices[1] || choices[0] : choices[0];
        const referenceRate = BmQuantityOffers.discountRate(referenceQuantity,discountEligible);
        const referenceTotal = BmQuantityOffers.offerTotal(price,referenceQuantity,discountEligible);
        const hasAdvantage = position > 0 && valid(quantity) && (rate > referenceRate || shippingIncluded && referenceTotal < threshold);
        button.dataset.bmOfferAdvantage = String(hasAdvantage);
        const recommendation = button.querySelector('[data-bm-offer-recommendation]');
        recommendation.hidden = !hasAdvantage;
        recommendation.textContent = this.config.messages[position === 1 ? 'recommended' : 'moreValue'];
        const description = position === 0 ? 'firstOrder' : shippingIncluded && rate > 0 ? 'discountAndShipping' : shippingIncluded ? 'freeShipping' : rate > 0 ? 'bestUnitPrice' : 'oneOrder';
        button.querySelector('[data-bm-offer-description]').textContent = this.config.messages[description];
        const art = button.querySelector('[data-bm-offer-art]');
        const visualCount = Math.min(quantity,6);
        art.className = `bm-offer-art bm-offer-art--${visualCount}`;
        if (this.packTemplate && art.children.length !== visualCount) art.replaceChildren(...Array.from({length:visualCount},() => this.packTemplate.cloneNode(true)));
        button.disabled = busy || !valid(quantity);
        button.setAttribute('aria-pressed',String(selected === quantity && valid(quantity)));
        button.querySelector('[data-bm-offer-total]').textContent = this.money(total);
        button.querySelector('[data-bm-offer-unit]').textContent = this.message('unit',this.money(Math.round(total / quantity)));
        const badge = button.querySelector('[data-bm-offer-badge]');
        badge.hidden = rate === 0;
        badge.textContent = this.message('discount',String(rate));
        const saving = button.querySelector('[data-bm-offer-saving]');
        const productSaving = price * quantity - total;
        saving.hidden = productSaving === 0;
        saving.textContent = this.message('saving',this.money(productSaving));
        const shippingValue = button.querySelector('[data-bm-offer-delivery-value]');
        shippingValue.hidden = !shippingIncluded;
        shippingValue.textContent = this.message('shippingValue',this.money(shippingCost));
        const deliveryCost = button.querySelector('[data-bm-offer-delivery-cost]');
        deliveryCost.hidden = shippingIncluded || !valid(quantity);
        deliveryCost.textContent = shippingEligible ? this.message('shippingCost',this.money(shippingCost)) : this.config.messages.shippingCheckout;
        const combined = button.querySelector('[data-bm-offer-combined]');
        combined.hidden = !shippingIncluded || productSaving === 0;
        combined.textContent = this.message('combinedValue',this.money(productSaving + shippingCost));
        button.querySelector('[data-bm-offer-shipping]').hidden = !shippingIncluded;
        button.querySelector('[data-bm-offer-unavailable]').hidden = valid(quantity);
        const imageSource = this.hasAttribute('data-current-packaging') ? this.dataset.fallbackImage : variant.featured_image?.src || this.dataset.fallbackImage;
        if (imageSource) {
          const url = new URL(imageSource,window.location.origin);
          url.searchParams.set('width','180');
          for (const image of button.querySelectorAll('img')) {
            if (image.src !== url.href) {
              image.removeAttribute('srcset');
              image.src = url.href;
            }
          }
        }
      }
      const eligible = this.dataset.discountEligible === 'true' && !plan;
      this.querySelector('[data-bm-offers-auto-note]').hidden = !eligible;
      this.querySelector('[data-bm-offers-details]').hidden = !eligible;
      this.querySelector('[data-bm-offers-terms]').hidden = !eligible;
      this.querySelector('[data-bm-offers-comparison]').hidden = !eligible || !shippingEligible;
      const total = valid(selected) ? BmQuantityOffers.offerTotal(price,selected,discountEligible) : null;
      this.querySelector('[data-bm-offers-selected-total]').textContent = total === null ? this.config.messages.invalidQuantity : this.money(total);
      for (const sticky of this.pdp.querySelectorAll('[data-bm-offer-sticky-total]')) sticky.textContent = total === null ? this.money(price) : this.money(total);
      const delivery = this.querySelector('[data-bm-offers-delivery]');
      delivery.hidden = this.dataset.roShipping !== 'true' || total === null;
      if (!delivery.hidden) delivery.textContent = total >= threshold ? this.config.messages.shippingFree : this.message('shippingRemaining',this.money(threshold - total));
    }
  }
  customElements.define('bm-quantity-offers',BmQuantityOffers);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bm-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.biomeColorReady) return;
  window.biomeColorReady = true;
  const ready = () => {
    const configNode = document.getElementById('bm-config');
    if (!configNode) return;
    const config = JSON.parse(configNode.textContent);
    const adsConfigNode = document.getElementById('bm-ads-config');
    if (adsConfigNode) {
      try { Object.assign(config.messages,JSON.parse(adsConfigNode.textContent).messages); } catch (error) {}
    }
    const root = config.root.endsWith('/') ? config.root : config.root + '/';
    let toastTimer;
    let cartBusy = false;
    const disabledStates = new WeakMap();
    const diagnostic = (action,state,placement) => document.dispatchEvent(new CustomEvent('bm:diagnostic',{detail:{action,state,placement}}));
    const money = value => new Intl.NumberFormat('ro-RO', {style:'currency',currency:window.Shopify?.currency?.active || 'RON'}).format(value / 100);
    const message = (text, link = false) => {
      const toast = document.getElementById('bm-toast');
      if (!toast) return;
      toast.replaceChildren(document.createTextNode(text));
      if (link) { const a = document.createElement('a'); a.href = config.cart; a.textContent = config.messages.viewCart; toast.append(a); }
      toast.hidden = false;
      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => { toast.hidden = true; },6500);
    };
    const request = async (url, options = {}) => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(),20000);
      try {
        const response = await fetch(url, {credentials:'same-origin',signal:controller.signal,...options});
        let data;
        try { data = await response.json(); } catch (cause) { throw new Error(config.messages.error); }
        if (!response.ok || Number(data.status) >= 400) {
          const error = new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : config.messages.error);
          error.status = response.status;
          throw error;
        }
        return data;
      } finally { clearTimeout(timeout); }
    };
    const updateCount = cart => document.querySelectorAll('[data-bm-cart-count]').forEach(n => { n.textContent = cart.item_count; });
    const disableControls = (controls,busy) => controls.forEach(control => {
      if (busy) { disabledStates.set(control,control.disabled); control.disabled = true; }
      else if (disabledStates.has(control)) { control.disabled = disabledStates.get(control); disabledStates.delete(control); }
    });
    const setBusy = (form, busy) => {
      form.setAttribute('aria-busy',String(busy));
      disableControls(Array.from(form.elements).filter(control => control.matches('button[type="submit"],[data-bm-variant],select[name="selling_plan"]')),busy);
    };
    const closeDialog = dialog => { if(dialog?.open) dialog.close(); };
    const openDialog = id => { const d = document.getElementById(id); if(d?.showModal && !d.open) d.showModal(); };
    const refreshCart = (data, sectionId) => {
      updateCount(data);
      const html = data.sections?.[sectionId];
      if (!html) { window.location.assign(config.cart); return; }
      const parsed = new DOMParser().parseFromString(html,'text/html');
      const next = parsed.querySelector('[data-bm-cart]');
      const current = document.querySelector('[data-bm-cart]');
      if (current && next) {
        current.replaceWith(next);
        const status = next.querySelector('[data-bm-cart-status]');
        if (status) status.textContent = config.messages.cartUpdated || config.messages.added;
        document.dispatchEvent(new CustomEvent('bm:cart-updated',{detail:data}));
      } else window.location.assign(config.cart);
    };
    const changeCart = async (line, quantity) => {
      if (cartBusy) return;
      const section = line.closest('[data-bm-cart]');
      const sectionId = section.dataset.bmSection;
      const key = line.dataset.bmKey;
      const quantityInput = line.querySelector('[data-bm-cart-quantity]');
      const focusIndex = Array.from(section.querySelectorAll('[data-bm-line]')).indexOf(line);
      cartBusy = true;
      section.setAttribute('aria-busy','true');
      disableControls(Array.from(section.querySelectorAll('button,input')),true);
      const oldError = section.querySelector('[data-bm-cart-error]');
      if (oldError) { oldError.hidden = true; oldError.textContent = ''; }
      try {
        const data = await request(config.change + '.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity,sections:[sectionId],sections_url:window.location.pathname})});
        refreshCart(data,sectionId);
        diagnostic(quantity === 0 ? 'remove' : 'quantity','confirmed','cart');
        const nextInputs = document.querySelectorAll('[data-bm-cart-quantity]');
        if(nextInputs.length) nextInputs[Math.min(focusIndex,nextInputs.length-1)].focus({preventScroll:true});
        else document.querySelector('[data-bm-cart] h1')?.focus({preventScroll:true});
      } catch(error) {
        const box = section.querySelector('[data-bm-cart-error]');
        const uncertain=!error.status||error.status>=500;
        if(box){box.hidden=false;box.textContent=uncertain?(config.messages.cartUncertain||error.message):error.message;if(uncertain){const link=document.createElement('a');link.href=config.cart;link.className='bm-link';link.textContent=config.messages.viewCart;box.append(document.createTextNode(' '),link);}}
        if (quantityInput) quantityInput.value = quantityInput.defaultValue;
        disableControls(Array.from(section.querySelectorAll('button,input')),false);
        diagnostic(quantity === 0 ? 'remove' : 'quantity',uncertain ? 'uncertain' : 'rejected','cart');
      } finally {cartBusy=false;section.removeAttribute('aria-busy');}
    };
    document.addEventListener('click', async event => {
      const opener=event.target.closest('[data-bm-open]');
      if(opener){event.preventDefault();openDialog(opener.dataset.bmOpen);return;}
      if(event.target.closest('[data-bm-open-search]')){event.preventDefault();openDialog('bm-search');return;}
      const closer=event.target.closest('[data-bm-close]');
      if(closer){closeDialog(closer.closest('dialog'));return;}
      const toggle=event.target.closest('[data-bm-toggle]');
      if(toggle){const target=document.getElementById(toggle.dataset.bmToggle);target.hidden=!target.hidden;toggle.setAttribute('aria-expanded',String(!target.hidden));return;}
      const thumb=event.target.closest('[data-bm-image]');
      if(thumb){const gallery=thumb.closest('.bm-pdp-gallery');const img=gallery.querySelector('.bm-gallery-main');if(img){img.removeAttribute('srcset');img.src=thumb.dataset.bmImage;img.alt=thumb.dataset.bmAlt;img.parentElement.toggleAttribute('data-bm-packshot',thumb.dataset.bmPrimary==='true');}gallery.querySelectorAll('[data-bm-image]').forEach(b=>b.setAttribute('aria-pressed',String(b===thumb)));return;}
      const quantityButton=event.target.closest('[data-bm-quantity]');
      if(quantityButton){const holder=quantityButton.closest('.bm-quantity');const input=holder.querySelector('input');const old=Number(input.value)||Number(input.min)||0;const step=Number(input.step)||1;const next=Math.max(Number(input.min)||0,old+Number(quantityButton.dataset.bmQuantity)*step);if(input.max&&next>Number(input.max))return;if(input.hasAttribute('data-bm-cart-quantity')){if(cartBusy)return;await changeCart(input.closest('[data-bm-line]'),next);}else{input.value=next;input.dispatchEvent(new Event('change',{bubbles:true}));}return;}
      const remove=event.target.closest('[data-bm-remove]');
      if(remove){event.preventDefault();await changeCart(remove.closest('[data-bm-line]'),0);return;}
      const loadMore=event.target.closest('[data-bm-load-more]');
      if(loadMore){event.preventDefault();if(loadMore.getAttribute('aria-busy')==='true')return;loadMore.setAttribute('aria-busy','true');const oldText=loadMore.textContent;loadMore.textContent=config.messages.loading;try{const response=await fetch(loadMore.href,{credentials:'same-origin'});if(!response.ok)throw new Error(config.messages.error);const next=new DOMParser().parseFromString(await response.text(),'text/html');const grid=next.querySelector('[data-bm-grid]');const pagination=next.querySelector('[data-bm-pagination]');if(!grid||!pagination)throw new Error(config.messages.error);const currentGrid=document.querySelector('[data-bm-grid]');const ids=new Set(Array.from(currentGrid.children).map(n=>n.dataset.bmProduct));for(const card of Array.from(grid.children)){if(!ids.has(card.dataset.bmProduct))currentGrid.append(card);}document.querySelector('[data-bm-pagination]').replaceWith(pagination);const status=document.querySelector('[data-bm-grid-status]');if(status)status.textContent=currentGrid.children.length+' '+config.messages.productsShown;}catch(error){loadMore.removeAttribute('aria-busy');loadMore.textContent=oldText;message(error.message);}return;}
      const discount=event.target.closest('[data-bm-discount]');
      if(discount){
        const input=document.getElementById('bm-discount-code');
        const code=input.value.trim();
        if(!code||cartBusy)return;
        const section=discount.closest('[data-bm-cart]');
        const sectionId=section.dataset.bmSection;
        const status=section.querySelector('[data-bm-discount-status]');
        const controls=Array.from(section.querySelectorAll('button,input'));
        cartBusy=true;
        section.setAttribute('aria-busy','true');
        disableControls(controls,true);
        status.textContent=config.messages.loading;
        try{
          const data=await request(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:code,sections:[sectionId],sections_url:window.location.pathname})});
          const applied=(data.discount_codes||[]).some(d=>d.applicable&&d.code.toLowerCase()===code.toLowerCase());
          refreshCart(data,sectionId);
          const result=document.querySelector('[data-bm-discount-status]');
          if(result)result.textContent=applied?config.messages.discountApplied:config.messages.discountNotApplied;
          const nextInput=document.getElementById('bm-discount-code');
          if(nextInput){nextInput.value=code;nextInput.focus({preventScroll:true});}
          diagnostic('discount',applied?'confirmed':'rejected','cart');
        }catch(error){status.textContent=error.message;diagnostic('discount',error.status?'rejected':'uncertain','cart');}
        finally{cartBusy=false;section.removeAttribute('aria-busy');disableControls(controls,false);}
        return;
      }
    });
    document.addEventListener('keydown',event=>{
      if(event.key==='Enter'&&event.target.matches('[data-bm-cart-quantity]')){
        event.preventDefault();
        event.target.dispatchEvent(new Event('change',{bubbles:true}));
        return;
      }
      if(event.key==='Enter'&&event.target.matches('#bm-discount-code')){
        event.preventDefault();
        event.target.closest('[data-bm-cart]')?.querySelector('[data-bm-discount]')?.click();
      }
    });
    document.addEventListener('submit',async event=>{
      const form=event.target;
      if(form.matches('#bm-cart-form')){
        if(cartBusy){event.preventDefault();return;}
        if(event.submitter?.name==='checkout')diagnostic('checkout','intent','cart');
        return;
      }
      if(!form.matches('.bm-product-form,.bm-quick-add'))return;
      event.preventDefault();
      if(form.getAttribute('aria-busy')==='true'||cartBusy)return;
      const addingOnCart=document.querySelector('[data-bm-cart]');
      const errorBox=form.querySelector('.bm-form-error');
      if(errorBox){errorBox.hidden=true;errorBox.textContent='';}
      const placement=form.matches('[data-bm-cross-sell-form]')?'cross_sell':form.matches('.bm-protocol-form')?'protocol':event.submitter?.closest('[data-bm-sticky]')?'sticky':form.matches('.bm-quick-add')?'quick_add':'product';
      const body=new FormData(form);
      const addingControls=addingOnCart?Array.from(addingOnCart.querySelectorAll('button,input')):[];
      if(addingOnCart){cartBusy=true;addingOnCart.setAttribute('aria-busy','true');disableControls(addingControls,true);}
      cartBusy=true;
      setBusy(form,true);
      try{
        if(!body.get('selling_plan'))body.delete('selling_plan');
        const cartSection=document.querySelector('[data-bm-cart]');
        if(cartSection){body.set('sections',cartSection.dataset.bmSection);body.set('sections_url',window.location.pathname);}
        const addedResult=await request(config.add+'.js',{method:'POST',body});
        message(config.messages.added,true);
        diagnostic('add','confirmed',placement);
        try{
          const cart=await request(config.cart+'.js');
          if(cartSection){cart.sections=addedResult.sections;refreshCart(cart,cartSection.dataset.bmSection);}else{updateCount(cart);document.dispatchEvent(new CustomEvent('bm:cart-updated',{detail:cart}));}
          document.dispatchEvent(new CustomEvent('bm:cart-added',{detail:{...cart,bmAddedVariantIds:(addedResult.items||[addedResult]).map(item=>Number(item.variant_id||item.id)),bmPlacement:placement}}));
        }catch(error){message(config.messages.addedRefresh||config.messages.added,true);}
      }catch(error){
        const uncertain=!error.status||error.status>=500;
        const text=uncertain?(config.messages.cartUncertain||config.messages.error):error.message;
        if(errorBox){errorBox.hidden=false;errorBox.replaceChildren(document.createTextNode(text));const link=document.createElement('a');link.href=config.cart;link.className='bm-link';link.textContent=config.messages.viewCart;errorBox.append(document.createTextNode(' '),link);}
        else message(text,true);
        diagnostic('add',uncertain?'uncertain':'rejected',placement);
        try{updateCount(await request(config.cart+'.js'));}catch(refreshError){}
      }
      finally{cartBusy=false;setBusy(form,false);if(addingOnCart){addingOnCart.removeAttribute('aria-busy');disableControls(addingControls,false);}}
    });
    document.addEventListener('change',async event=>{
      const input=event.target;
      if(input.matches('[data-bm-cart-quantity]')){
        if(input.value.trim()===''||!input.checkValidity()){input.reportValidity();input.value=input.defaultValue;return;}
        await changeCart(input.closest('[data-bm-line]'),Number(input.value));return;
      }
      if(input.matches('[data-bm-sort]')){const form=input.closest('form');form.requestSubmit();return;}
      if(input.matches('[data-bm-variant],select[name="selling_plan"]')){
        const pdp=input.closest('[data-bm-pdp]');
        const variants=JSON.parse(pdp.querySelector('[data-bm-variants]').textContent);
        const variantId=pdp.querySelector('[name="id"]').value;
        const selected=variants.find(v=>String(v.id)===variantId);
        if(!selected)return;
        const plan=pdp.querySelector('[name="selling_plan"]');
        const allocation=selected.selling_plan_allocations?.find(a=>String(a.selling_plan_id||a.selling_plan?.id)===plan?.value);
        const price=allocation?.price??selected.price;
        if(plan){for(const option of plan.options){option.disabled=!!option.value&&!selected.selling_plan_allocations?.some(a=>String(a.selling_plan_id||a.selling_plan?.id)===option.value);}if(plan.selectedOptions[0]?.disabled){plan.value='';}}
        pdp.querySelectorAll('[data-bm-price]').forEach(n=>{n.textContent=money(price);});
        const unit=pdp.querySelector('[data-bm-unit-price]');if(unit)unit.textContent=money(Math.round(price/Number(unit.dataset.days)))+' / '+config.messages.day;
        pdp.querySelectorAll('[data-bm-atc]').forEach(b=>{b.disabled=!selected.available;});
        pdp.querySelectorAll('[data-bm-atc-label]').forEach(n=>{n.textContent=selected.available?config.messages.add:config.messages.soldOut;});
        const stock=pdp.querySelector('[data-bm-stock]');if(stock)stock.hidden=!selected.available;
        if(selected.featured_image?.src&&!pdp.hasAttribute('data-bm-current-packaging')){const image=pdp.querySelector('.bm-gallery-main');if(image){image.removeAttribute('srcset');image.src=selected.featured_image.src;}}
        const url=new URL(window.location.href);url.searchParams.set('variant',selected.id);window.history.replaceState({},'',url);
      }
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready,{once:true});else ready();
})();
document.addEventListener('click',event=>{const target=event.target.closest('[data-bm-filter-target]');if(!target)return;const panel=document.getElementById('bm-filter-panel');if(panel){panel.hidden=false;document.querySelector('[aria-controls="bm-filter-panel"]')?.setAttribute('aria-expanded','true');const field=document.getElementById(target.dataset.bmFilterTarget);field?.scrollIntoView({behavior:'smooth',block:'nearest'});field?.querySelector('input')?.focus({preventScroll:true});}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bm-v9-interactions"] && !Shopify.designMode) return;
  try {
    (() => {
  const desktop = window.matchMedia('(min-width: 761px)');
  let observer;
  let galleries = [];
  let header;
  let frame = 0;
  const setValue = (element, name, value) => {
    if (element.style.getPropertyValue(name) !== value) element.style.setProperty(name, value);
  };
  const measure = () => {
    frame = 0;
    if (!desktop.matches || document.body.classList.contains('bm-phone-stage')) return;
    const headerHeight = Math.ceil(header?.getBoundingClientRect().height || 88) + 16;
    const sizes = galleries.filter(gallery => gallery.isConnected).map(gallery => ({
      element: gallery,
      height: Math.ceil(gallery.getBoundingClientRect().height)
    }));
    sizes.forEach(({ element, height }) => {
      setValue(element, '--bm-gallery-header', `${headerHeight}px`);
      setValue(element, '--bm-gallery-height', `${height}px`);
    });
  };
  const schedule = () => {
    if (!frame) frame = window.requestAnimationFrame(measure);
  };
  const connect = () => {
    observer?.disconnect();
    galleries = [...document.querySelectorAll('.bm-pdp-layout > .bm-pdp-gallery')];
    if (!galleries.length || document.body.classList.contains('bm-phone-stage')) return;
    header = document.querySelector('#shopify-section-bm-header') || document.querySelector('[data-bm-header]');
    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(schedule);
      galleries.forEach(gallery => observer.observe(gallery));
      if (header) observer.observe(header);
    }
    schedule();
  };
  desktop.addEventListener('change', schedule);
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', connect);
  document.addEventListener('shopify:section:unload', connect);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connect, { once: true });
  else connect();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bm-welcome-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = () => {
    const dialog = document.querySelector('[data-bm-welcome-popup]');
    if (!dialog || dialog.dataset.initialized || typeof dialog.showModal !== 'function') return;
    dialog.dataset.initialized = 'true';
    const seenKey = 'bm-welcome-newsletter-seen-v1';
    const dismissedKey = 'bm-welcome-newsletter-dismissed-v1';
    const actionKey = 'bm-welcome-newsletter-shopping-v1';
    const started = Date.now();
    const mobile = window.matchMedia('(hover: none) and (pointer: coarse)').matches || window.matchMedia('(max-width: 760px)').matches;
    const getSaved = (store, key) => { try { return window[store].getItem(key); } catch (error) { return null; } };
    const save = (store, key, value) => { try { window[store].setItem(key, value); } catch (error) {} };
    const recentDismissal = Date.now() - Number(getSaved('localStorage', dismissedKey)) < 7 * 24 * 60 * 60 * 1000;
    let suppressed = Number(dialog.dataset.bmWelcomeCart) > 0 || dialog.dataset.bmWelcomeSubscribed === 'true' || !!getSaved('sessionStorage', seenKey) || !!getSaved('sessionStorage', actionKey) || recentDismissal;
    let opener;
    let idleTimer;
    let deepestScroll = 0;
    let lastScroll = window.scrollY;
    let lastScrollAt = Date.now();
    let upScrollStart = window.scrollY;
    let upScrollStartedAt = Date.now();
    const visible = element => !!element && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
    const blocked = () => {
      if (document.hidden || [...document.querySelectorAll('dialog[open], [aria-modal="true"]:not([hidden])')].some(visible)) return true;
      if (document.activeElement?.matches('input,textarea,select,[contenteditable="true"]')) return true;
      if (document.querySelector('form[aria-busy="true"], [data-bm-cart][aria-busy="true"], bm-routine-quiz [data-quiz-flow]:not([hidden])')) return true;
      if ([...document.querySelectorAll('#shopify-pc__banner,#shopify-pc__prefs,.otCookiesNotification,.cc-window,.cky-consent-container,[data-cookie-banner],[id*="cookie-banner"],[class*="consent-banner"]')].some(visible)) return true;
      return false;
    };
    const engaged = () => Date.now() - started >= 20000 && deepestScroll >= .2;
    const automaticAllowed = () => !suppressed && engaged() && dialog.dataset.bmWelcomeEditor !== 'true' && !['cart','customers/login','customers/account'].includes(dialog.dataset.bmWelcomePage) && !location.pathname.includes('/checkout') && !document.querySelector('bm-routine-builder');
    const open = manual => {
      if (dialog.open || blocked() || (!manual && !automaticAllowed())) return false;
      opener = document.activeElement;
      dialog.showModal();
      document.documentElement.classList.add('bm-welcome-is-open');
      save('sessionStorage', seenKey, '1');
      suppressed = true;
      clearTimeout(idleTimer);
      return true;
    };
    const suppressShopping = () => {
      suppressed = true;
      clearTimeout(idleTimer);
      save('sessionStorage', actionKey, '1');
    };
    const dismiss = () => {
      suppressed = true;
      clearTimeout(idleTimer);
      save('localStorage', dismissedKey, String(Date.now()));
      if (dialog.open) dialog.close();
    };
    const armInactivity = () => {
      clearTimeout(idleTimer);
      if (mobile && automaticAllowed()) idleTimer = setTimeout(() => open(false), 45000);
    };
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('bm-welcome-is-open');
      suppressed = true;
      clearTimeout(idleTimer);
      save('localStorage', dismissedKey, String(Date.now()));
      if (opener?.isConnected) opener.focus({ preventScroll: true });
    });
    dialog.addEventListener('click', event => {
      if (event.target.closest('[data-bm-welcome-close]')) dismiss();
      if (event.target === dialog) {
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dismiss();
      }
    });
    document.addEventListener('click', event => {
      if (event.target.closest('[data-bm-welcome-open]')) { event.preventDefault(); open(true); }
      if (event.target.closest('[data-bm-add],[data-bm-atc],[name="add"],[href*="/checkout"],[href*="/cart"]')) suppressShopping();
    });
    document.addEventListener('submit', () => { suppressed = true; clearTimeout(idleTimer); }, true);
    document.addEventListener('bm:cart-updated', suppressShopping);
    document.addEventListener('bm:diagnostic', event => { if (event.detail?.action === 'add') suppressShopping(); });
    document.addEventListener('bm:quiz-start', () => { suppressed = true; clearTimeout(idleTimer); });
    document.addEventListener('pointerout', event => {
      if (!mobile && event.pointerType === 'mouse' && event.relatedTarget === null && event.clientY <= 8) open(false);
    });
    window.addEventListener('scroll', () => {
      const now = Date.now();
      const currentScroll = window.scrollY;
      const depth = currentScroll / Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      deepestScroll = Math.max(deepestScroll, depth);
      if (currentScroll >= lastScroll || now - lastScrollAt > 250) {
        upScrollStart = currentScroll;
        upScrollStartedAt = now;
      }
      const upDistance = upScrollStart - currentScroll;
      const upDuration = Math.max(1, now - upScrollStartedAt);
      const fastUp = upDistance >= 120 && upDuration <= 400 && upDistance / upDuration >= .6;
      if (upDuration > 400) {
        upScrollStart = currentScroll;
        upScrollStartedAt = now;
      }
      lastScroll = currentScroll;
      lastScrollAt = now;
      if (mobile && fastUp) open(false);
      armInactivity();
    }, { passive: true });
    ['pointerdown','keydown','touchstart'].forEach(type => document.addEventListener(type, armInactivity, { passive: true }));
    const submitted = dialog.querySelector('[data-bm-welcome-success],[data-bm-welcome-error]');
    if (submitted) { open(true); return; }
    setTimeout(armInactivity, 20000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
  } catch(e) { console.error(e); }
})();

})();
